module.exports = __webpack_public_path__ + "img/arrow-up-1.fa96f565.svg";